import React, {Component} from 'react';
import PropTypes from 'prop-types';
import "./index.css";

class SearchBar extends Component {
    componentDidUpdate() {
        let searchBar = document.querySelector(".search_bar-container");
        searchBar.style.width = this.props.collapsed ? "46px" : "200px";
    }

    _handleChange = (e) => {
        this.props.onSearch(e.target.value);
    }

    _handleFocus = () => {
        if (this.props.searchQuery) {
            this.props.onSearch(this.props.searchQuery);
        }
        this.props.onSearchFocus();
    }

    _handleBlur = () => {
        this.props.onSearchBlur();
    }

    _handleToggleClick = () => {
        const handler = this.props.collapsed ? this.props.expandButtonHandler : this.props.collapseButtonHandler;
        handler();
    }

    render() {
        return (
            <div className={"search_bar-container"}>
                { this.props.collapsed ? null :
                    <><div className={"search-icon-container"}>
                        <span className={"snap-icon-search"} />
                    </div>
                    <input type="text" id={"search-bar"} placeholder={"Search..."} value={this.props.searchQuery}
                        onChange={this._handleChange}
                        onFocus={this._handleFocus}
                        onBlur={this._handleBlur}
                    /></>
                }
                <button type="button" className={"expand-collapse-container " + (this.props.collapsed ? "collapsed" : "")}
                    onClick={this._handleToggleClick}>
                    <span className={"snap-icon-chevron_right"}></span>
                </button>
            </div>
        );
    }
}

SearchBar.propTypes = {
    collapsed: PropTypes.bool,
    searchQuery: PropTypes.string,
    onSearch: PropTypes.func,
    onSearchFocus: PropTypes.func,
    onSearchBlur: PropTypes.func,
    expandButtonHandler: PropTypes.func,
    collapseButtonHandler: PropTypes.func
};

export default SearchBar;
